import React from 'react'
import './WelcomeModal.scoped.sass'

import { Button } from '@/components/Button/Button'

const WelcomeModal = (props) => {
  const {
    closeModal,
    continueOnboarding,
    usage,
  } = props

  return (
    <div className='main-container'>
      <div className='welcome-header'>
        Welcome to Boxes! &#128075;
      </div>
      <div className='info'>
        <p>Hey there! We are really happy to have you join Boxes.</p>
      </div>
      <div className='info'>
        <p><b>Your account, your rules.</b></p>
      </div>
      <div className='info'>
        <p>As a Boxes member, you can enjoy email at its best. End the messy inbox and getting lost inside an unmanageable list of emails. With Boxes you can have as many inboxes and labels as you need to keep your email simple and auto-categorized.</p>
      </div>
      <div className='info'>
        <p><b>Let's onboard you into the Email Evolved movement.</b></p>
      </div>
      <div className='info'>
        <p>We will set up a few labels for you to get started and we'll send you a welcome message which will create your first box!</p>
      </div>
      <div className='buttons'>
        <div className='skip-button'>
          <Button content='Skip' type='secondary' click={closeModal} className='skip-button' size='regular'/>
        </div>
        <div className='quick-setup-button'>
          <Button content='Quick Setup' click={continueOnboarding} className='quick-setup-button' size='regular' usage={usage}/>
        </div>
      </div>
    </div>
  )
}

export default WelcomeModal
